// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MHtR","col":"styles_col__2OAN4"};